import EF from 'ef/ef';
import Chaplin from 'chaplin';
import Resource from 'ef/models/resource';
import $ from 'jquery';
import utils from 'lib/utils';
/*/ ## EF.Collections.ResourcesCollection
//
// Collection for resources and policies associated with
// and enrollment */
const ResourcesCollection = Chaplin.Collection.extend({
  model: Resource,
  fileName: 'resources.json',
  initialize: function (models, options) {
    this.enrollment = options.enrollment;
    this.on('add', this.onAdd);
  },
  url: function () {
    return utils.getEnrollmentsUrl(this.enrollment.get('id'), this.fileName);
  },
  sync: function () {
    return utils.backboneSync(this, arguments);
  },
  onAdd: function (resource) {
    resource.enrollment = this.enrollment;
  },
  byType: function (type, sub_type) {
    const deferred = $.Deferred();
    const self = this;
    let resources;
    if (this.length > 0) {
      resources = self.byTypeSync(type, sub_type);
      deferred.resolve(resources);
    } else {
      EF.ContentProvider.ResourceService.loadResources().then(function () {
        resources = self.byTypeSync(type, sub_type);
        deferred.resolve(resources);
      });
    }
    return deferred.promise();
  },
  byTypeSync: function (type, subType) {
    const models = this.models;
    const filterResources = sub => models.filter(model => model.attributes.sub_type === sub);
    let resources;
    if (subType) {
      // if subType consists of multiple objects, iterate and assign props
      // otherwise filter only once
      const subTypes = Array.isArray(subType) ? subType : [subType];
      subTypes.forEach(e => {
        const thisResource = filterResources(e);
        resources = resources ? resources.concat(thisResource) : thisResource;
      });
    } else {
      // if there is no subtype and type is Resource, filter resources to not include PolicyResource type
      const isResource = type === 'Resource';
      resources = models.filter(({ attributes: { type: modelType } }) => {
        return isResource ? modelType !== 'PolicyResource' : modelType === type;
      });
    }
    return resources;
  },
  checkIfAllResourcesSigned: function (sub_type) {
    return this.byTypeSync('PolicyResource', sub_type).every(res => res.get('signed'));
  },
});

export default ResourcesCollection;
